import { AbstractControl } from '@angular/forms';

export function validateUsername(control: AbstractControl): 
                                { [key: string]: boolean } | null 
{
    let userNameValidation = {invalidUsername : true};
        
    return null;
/*    
    console.log('****VALIDATE*****');
    console.log(control.value);
    if (control.value != 'dmvCypher')
    {
        return {'invalidUsername' : false};            
    }
    else
    {
        return null;
    }
*/
}    
